var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { combineReducers } from "redux";
import { AlertReducer } from "./views/Alert/ducks/AlertReducer.js";
import currentUserDetailsReducersMapObject from "@ane/exp-data/lib/userDetails/CurrentUserDetailsReducer";
import getWorkspaceReducersMapObject from "@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.ducks";
import { createNamedWrapperReducer } from "@ane/exp-data/lib/utils/AppModuleReducerUtils";
import { resolveGateReducer } from "./views/ResolveGate/ResolveGate.ducks.js";
import { overrideGateReducer } from "./views/OverrideGate/OverrideGate.ducks.js";
const getAlertReducer = (propertyName) => createNamedWrapperReducer(AlertReducer, propertyName);
const moduleReducer = __spreadValues(__spreadValues({
  gates: combineReducers({
    resolve_gate: resolveGateReducer,
    override_gate: overrideGateReducer
  })
}, getWorkspaceReducersMapObject), currentUserDetailsReducersMapObject);
export {
  getAlertReducer,
  moduleReducer
};
//# sourceMappingURL=reducers.js.map
